<template>
  <div v-loading="loading">
    <div class="store-title-container">
      <div class="left-btn-container">
        <span class="store-title">企业主页设置</span>
        <eui-btn type="text" @click="() => goPath()">主页预览</eui-btn>
      </div>
      <eui-btn type="text" @click="goPath('/store')">返回店铺配置</eui-btn>
    </div>
    <div class="store-container">
      <div class="title-wrap">
        <h2 class="title">审核状态</h2>
      </div>
      <div class="audit-container">
        <div class="audit-img-container">
          <!-- <img :src="passImg" alt="" width="204" height="120" /> -->
          <img :src="auditImg" alt="" :width="imgWidth" height="120" />
        </div>
        <p>{{ auditMessage }}</p>
      </div>
      <div v-if="auditStatus === 3" class="reject-container">
        <div class="icon-container">
          <eui-icon icon="eicon-r-tanhao" font-size="18px" color="#EA9200"></eui-icon>
        </div>
        <div class="reject-content">
          <span>
            {{ reason }}
          </span>
        </div>
      </div>
    </div>

    <div class="store-container">
      <div class="title-wrap">
        <h2 class="title">上传企业视频介绍</h2>
        <div class="title-tips">
          <el-popover placement="right" trigger="hover" popper-class="store-show">
            <img src="@/assets/img/store/video.jpg" alt="" height="320" />
            <div slot="reference">
              <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
              <span>示例</span>
            </div>
          </el-popover>
        </div>
      </div>
      <div v-if="enterpriseInfo.videoFileList.length > 0 && enterpriseInfo.videoFileList[0].url">
        <!-- 先有url 在有html 播放就没问题 -->
        <video id="video-modal" width="200" height="120" controls loop style="object-fit: cover">
          <source :src="enterpriseInfo.videoFileList[0].url" />
        </video>
      </div>
    </div>

    <div class="store-container">
      <div class="title-wrap">
        <h2 class="title">上传企业宣传图片</h2>
        <div class="title-tips">
          <el-popover placement="right" trigger="hover" popper-class="store-show">
            <img src="@/assets/img/store/img.jpg" alt="" height="320" />
            <div slot="reference">
              <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
              <span>示例</span>
            </div>
          </el-popover>
        </div>
      </div>
      <!-- <eui-upload
        ref="euiUploadSix"
        list-type="picture-card"
        class="store-single"
        :class="{ 'no-upload': enterpriseInfo.slides.slidesFileList.length >= 6 }"
        :file-list="enterpriseInfo.slides.slidesFileList"
        :action="zoneConfigurationImageUpload"
        :headers="headers"
        accept=".png,.jpg,.jpeg"
        show-file-list
        :limit="6"
        @handleSuccess="videoSuccess"
      ></eui-upload> -->
      <div>
        <el-image
          v-for="item in enterpriseInfo.slidesFileList"
          :key="item.id"
          style="width: 100px; height: 100px; margin-right: 10px"
          :src="item.url"
          :preview-src-list="[item.url]"
        ></el-image>
      </div>
    </div>

    <div class="store-container">
      <div class="title-wrap">
        <h2 class="title">企业简介</h2>
        <div class="title-tips">
          <el-popover placement="right" trigger="hover" popper-class="store-show">
            <img src="@/assets/img/store/desc.jpg" alt="" height="320" />
            <div slot="reference">
              <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
              <span>示例</span>
            </div>
          </el-popover>
        </div>
      </div>
      <!-- <el-input
        v-model="enterpriseInfo.profile.enterpriseProfile"
        type="textarea"
        placeholder="请输入公司简介"
        maxlength="2000"
        show-word-limit
        :rows="4"
      ></el-input> -->
      <div>
        <el-scrollbar ref="scrollbar" style="height: 148px">
          <div class="text">
            {{ enterpriseInfo.enterpriseProfile }}
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="store-container">
      <div class="title-wrap">
        <h2 class="title">VR地址</h2>
      </div>
      <div>{{ enterpriseInfo.vrUrl }}</div>
    </div>
    <div class="store-container">
      <div class="title-wrap">
        <h2 class="title">企业资质</h2>
      </div>
      <div class="message-wrapper">
        <div class="message-left">提示：</div>
        <div class="message-content">
          <p>请确保您充分知悉并符合以下基本条件及说明：</p>
          <p>1.提交的信息真实，证明文件有效。</p>
          <p>2.易派客有权对上传的文件进行不定期抽查，以核实真实性、合法性和效力状态。</p>
          <p>
            3.上传的证书需不侵犯他人知识产权，需按自有资质要求上传，正确的数据，合法的数据，如有法律分险，需自行承担。
          </p>
        </div>
      </div>
      <EnterpriseInfo
        ref="enterpriseInfo"
        :tabs="enterpriseInfo.tabsList"
        is-view
        :status="1"
        @getIndex="getIndex"
      ></EnterpriseInfo>
      <div class="message-tips">{{ messages[currentIndex] }}</div>
    </div>

    <div class="handle-btn">
      <eui-btn type="secondary" @click="goPath('/store')">关闭</eui-btn>
      <eui-btn v-if="auditStatus === 1" @click="handleCancel">撤回</eui-btn>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/cms/index';
import { epecMallUrl } from '@/modules/projectA/api/config';
import EnterpriseInfo from './components/enterpriseInfo.vue';
/* import ProductConfig from './components/goods.vue'; */

import { videoFileUpload, zoneConfigurationImageUpload, headers } from './mixins';

export default {
  components: { EnterpriseInfo },
  data() {
    return {
      /* passImg: require('@/assets/img/store/pass.png'),
      rejectImg: require('@/assets/img/store/reject.png'),
      paddingImg: require('@/assets/img/store/padding.png'),
      //  1-审核中 2-审核通过 3-审核拒绝
      // 恭喜！您提交的资料已经顺利通过审核啦！
      // 您提交的资料我们已经收到，我们将尽快完成资料审核，请耐心等待，谢谢！
      // 您提交的资料审核未通过，请按提示内容修改后，再次提交审核。 */
      loading: false,
      auditMessage: '',
      auditImg: '',
      imgWidth: '120',
      auditStatusList: [
        {
          status: 1,
          message: '您提交的资料我们已经收到，我们将尽快完成资料审核，请耐心等待，谢谢！',
          img: require('@/assets/img/store/padding.png'),
        },
        {
          status: 2,
          message: '恭喜！您提交的资料已经顺利通过审核啦！',
          img: require('@/assets/img/store/pass.png'),
        },
        {
          status: 3,
          message: '您提交的资料审核未通过，请按提示内容修改后，再次提交审核。',
          img: require('@/assets/img/store/reject.png'),
        },
      ],
      auditStatus: 0,
      messages: [
        '提示：经营资质包括营业执照、税务登记证、组织机构代码证。',
        '提示：许可资质：包括生产许可证、特种设备制造许可证、CCC认证、代理商的各种授权书、质量管理体系认证、环境管理体系认证、职业健康安全管理体系认证、知识产权管理体系认证等。',
        '提示：能力资质包括企业获得的由地方、国家、专业机构、行业协会颁发的相应资质证书等；获奖证书、专利等。',
        '提示：其他资质包括供应服务能力（销售业绩、企业产能、生产检验设备、仓储运输能力、研发能力、售后能力等介绍，非证书类）、知识创新能力（专利清单、商标清单、知识产权清单、创新研发介绍等，非证书类）、其他证书。',
      ],
      currentIndex: 0,
      videoFileUpload,
      zoneConfigurationImageUpload,
      headers,

      enterpriseInfo: {
        videoFileList: [{ url: '', text: 'video' }],
        videoEnable: true,
        slidesFileList: [],
        slidesEnable: true,

        enterpriseProfile: '',
        enterpriseProfileEnable: true,
        vrUrl: 'https://element.eleme.cn/#/zh-CN/component/switch',
        vrEnable: true,
        qualificationEnable: true,
        tabsList: [
          {
            label: '经营资质',
            value: 0,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '许可资质',
            value: 1,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '能力资质',
            value: 2,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '其他相关资质',
            value: 3,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
        ],
      },
    };
  },
  computed: {},
  mounted() {
    this.getDetailInfo();
    this.checkAuditStatus();
  },
  methods: {
    async checkAuditStatus() {
      try {
        this.loading = true;
        const { companyId } = this.$store.state.USERINFO;
        const { data = {}, code } = await Api.auditStatus({ companyId });
        if (code === '200') {
          this.loading = false;
          this.auditStatus = data.auditStatus || 0;
          const { message, img } =
            this.auditStatusList.find((item) => {
              return item.status === this.auditStatus;
            }) || {};
          this.auditMessage = message;
          this.auditImg = img;
          this.imgWidth = this.auditStatus === 1 ? '204' : '120';
          this.reason = data.reason;
        }
      } catch (err) {
        this.loading = false;
        console.log('err:', err);
      }
    },
    async handleCancel() {
      try {
        const { companyId } = this.$store.state.USERINFO;
        const { code } = await Api.cancel({ companyId });
        if (code === '200') {
          this.$message.success('撤回审核成功');
          this.goPath('/store');
        }
      } catch (err) {
        console.log(err);
      }
    },
    getIndex(index) {
      this.currentIndex = index;
    },
    goPath(path) {
      if (path) {
        this.$router.push(path);
        return;
      }
      const { companyId, companyName } = this.$store.state.USERINFO;
      window.open(`${epecMallUrl}/supplier?companyId=${companyId}&companyName=${companyName}&view=1`);
    },
    async getDetailInfo() {
      const { companyId } = this.$store.state.USERINFO;
      const result = await Api.auditContent({ companyId });
      if (result.code === '200') {
        const contentTemplate = result.data ? JSON.parse(result.data) : {};
        this.enterpriseInfo = { ...this.enterpriseInfo, ...contentTemplate };
        this.$nextTick(() => {
          this.$refs.scrollbar.update();
        });
        console.log(this.enterpriseInfo, 'this.enterpriseInfo');
      }
    },
    handleParameterImgList(val) {
      console.log(val);
    },
    // 操作人附件上传
    videoSuccess(obj) {
      console.log(obj);
      if (obj.code === '200') {
        const slidesFileList = this.enterpriseInfo.slides.slidesFileList.map((item) => {
          item.url = item?.response?.data?.url || item.url;
          return item;
        });

        this.enterpriseInfo.slides.slidesFileList = slidesFileList;
      }
    },
    onSetting(val) {
      this.enterpriseInfo.paneList = val;
    },
    async save() {
      function isValidURL(url) {
        // 匹配 http 或 https 开头，随后是域名部分（包括二级域名和顶级域名），允许端口号、路径、查询参数等
        const regex = /^https/;
        return regex.test(url);
      }

      if (this.enterpriseInfo.vrUrl && !isValidURL(this.enterpriseInfo.vrUrl)) {
        this.$message.warning('VR链接格式错误');
        return;
      }

      const { tabsList } = this.$refs.enterpriseInfo;
      const contentTemplate = JSON.stringify({
        ...this.enterpriseInfo,
        qualification: {
          enable: true,
          tabsList,
        },
      });

      const result = await Api.saveCompanyConfiguration({ contentTemplate });
      if (result.code === '200') {
        this.$message({
          message: '保存成功',
          type: 'success',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden !important;
}

::v-deep .el-scrollbar__view {
  height: 148px;
}
.store-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .left-btn-container {
    display: flex;
    align-items: center;
    .store-title {
      font-size: 16px;
      color: #333;
      margin-right: 10px;
    }
  }
}
.store-container {
  min-width: 880px;
  overflow: auto;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  /* ::v-deep .no-upload {
    .el-upload--picture-card {
      display: none;
    }
  } */
  .audit-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .audit-img-container {
      margin-bottom: 20px;
    }
    p {
      font-size: 16px;
      color: #333;
    }
  }
  .reject-container {
    display: flex;
    margin-top: 10px;
    padding: 15px 10px;
    background-color: rgba(229, 1, 19, 0.06);
    .icon-container {
      margin-right: 10px;
    }
    .reject-content {
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
  }
  ::v-deep .store-single {
    & > div:nth-of-type(1) {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;
    }
    .el-upload-list__item,
    .file_cord_item {
      width: 100px;
      height: 100px;
    }
    .el-upload-list {
      padding-left: 10px;
    }
    .file_cord_item {
      &:hover {
        .cord_item_btn {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .el-upload-list__item {
      border: 1px solid #d9d9d9;
    }
    .upload_cord,
    .el-upload--picture-card {
      width: 100px;
      height: 100px;
    }
    .el-upload--picture-card {
      border: 1px solid #d9d9d9;
    }
  }
  .title-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .title {
      margin-right: 8px;
      line-height: 1;
      font-size: 16px;
      color: #333;
    }
    .title-tips {
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        margin-left: 4px;
        color: #c5c5c5;
        font-size: 12px;
      }
      ::v-deep .el-popover__reference {
        display: flex;
        align-items: center;
      }
    }
  }
  .message-wrapper {
    display: flex;
    margin-bottom: 20px;
    padding: 16px 10px;
    background: #e8efff;
    font-size: 14px;
    color: #333;
    .message-left {
      font-weight: bold;
      color: #f0250f;
      white-space: nowrap;
    }
    p {
      margin-bottom: 2px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.message-tips {
  margin-top: 10px;
  color: #999;
  font-size: 14px;
}
.handle-btn {
  display: flex;
  justify-content: center;
}
</style>
